import React, { Component } from 'react';
import { Link, Route } from 'react-router-dom';
import {
  Button,
  DatePickerSkeleton,
  Table,
  Form,
  FormGroup,
  FormLabel,
  TableToolbar,
  Pagination,
  TextInput,
  TableHeader,
  TableHead,
  TableBody,
  TableRow,
  TableContainer,
  TableCell,
  DataTable,
  DataTableSkeleton,
  Tab,
  Search,
  ModalWrapper,
  Loading,
} from 'carbon-components-react';
import Add16 from '@carbon/icons-react/lib/add/16';
import Edit16 from '@carbon/icons-react/lib/edit/16';
import Box16 from '@carbon/icons-react/lib/box/16';
import DocumentExport16 from '@carbon/icons-react/lib/document--export/16';
import ExportDoc16 from '@carbon/icons-react/lib/document--export/16';
import FolderDetail16 from '@carbon/icons-react/lib/folder--details/16';
import Data16 from '@carbon/icons-react/lib/data--1/16';
import { Download16 } from '@carbon/icons-react/lib/';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import {
  RenderDataTableCell,
  NoRecordsPlaceholder,
} from '../../helpers/jsonschemaform/DataTableExtention';
import { api } from '../../helpers/api/api';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, entitiesLabels, apioperation, DateFormat } from '../../helpers/Constants';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import DateTimePicker from '../../helpers/DateTimePicker';
import ReportRepository from '../../helpers/api/ReportRepository';
import { Online } from '../common/OnLineOffLine';
import FileDownLoadButton from '../common/FileDownloadButton';

export default class ReportSummaryList extends Component {
  searchProp = () => ({
    startDate: null,
    endDate: null,
      idWorksite: null,
      idCompany: null,
      idDivision: null,
      idProject: null,
      idCountry: null,
      idSubDivision: null,
      idActivity: null,
  });
  constructor(props) {
    super(props);
    this.state = {
      isOpenFilter: false,
      isLoadingList: true, // TODO CAMBIARE
      isLoadingOptions: true,
      itemList: [],
      // filters options
      yearsOptions: [],
      workSiteOptions: [],
      projectOptions: [],
      divisionOptions: [],
      countryOptions: [],
      companyOptions: [],
      subDivisionOptions: [],
      activityOptions: [],
      //ResetFilter
      isBack: this.props.history.action === 'POP' || this.props.location.search === '?isBack' ? true: false,
      // paging
      currentPage: 1,
      pageCount: 0,
      pageSize: 10,
      rowCount: 0,
      // filters
      workSite: undefined,
      project: undefined,
      division: undefined,
      country: undefined,
      company: undefined,
      activity: undefined,
      subDivision: undefined,
      searchModel: {
        ...this.searchProp(),
      },
    };
    //this.updateState = this.updateState.bind(this);
  }

    handleFilterChange = (filter, selectedItem) => {
    const newState = {};
        newState[filter] = (selectedItem && selectedItem.id) || null;
    this.setState(newState);
  };


  showDivFilter = () => {
    this.setState((oldState) => ({ isOpenFilter: !oldState.isOpenFilter }));
  };
  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;
    statusCopy.isBack =false;
    this.setState(statusCopy, );
    
  };
  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
      statusCopy[objName][inputName] = inputValue;
      if (objName === 'searchModel') { statusCopy.isBack = false;}
    this.setState(statusCopy);
  };
  divFiterAudit = (filterItems) =>
    this.state.isLoadingOptions ? (
      <Loading withOverlay={false} active className="centered" />
    ) : (
      <div>
        <Form autoComplete="off" className="bx--row" onSubmit={this.handleClickSearch}>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText="Reports Start Date">
              {this.state.isLoadingDate ? (
                <DatePickerSkeleton />
              ) : (
                <DateTimePicker
                  value={this.state.searchModel?.startDate}
                  type="date"
                  placeholder={DateFormat}
                  name="startDate"
                  alt="searchModel"
                  // invalid={validations.dueDate != null}
                  onChange={this.updateState}
                  disabled={this.state.isDisabled}
                />
              )}
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
             <FormGroup legendText="Reports End Date">
              {this.state.isLoadingDate ? (
                <DatePickerSkeleton />
              ) : (
                <DateTimePicker
                value={this.state.searchModel?.endDate}
                  type="date"
                  placeholder={DateFormat}
                  name="endDate"
                  alt="searchModel"
                  // invalid={validations.dueDate != null}
                  onChange={this.updateState}
                  disabled={this.state.isDisabled}
                />
              )}
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText="Worksite">
            <ComboBox
                id="idWorksite"
                placeholder="All"
                name="idWorksite"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={ filterItems.idWorksite}
                items={this.state.workSiteOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText="Operating Company/Branch">
              <ComboBox
                id="idCompany"
                placeholder="All"
                name="idCompany"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={ filterItems.idCompany }
                items={this.state.companyOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText=" Project">
              <ComboBox
                id="idProject"
                placeholder="All"
                name="idProject"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={ filterItems.idProject }
                items={this.state.projectOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            {/* RITM0945977 */}
            {/* <FormGroup legendText="Main Division"> */}
            <FormGroup legendText="Main Business Line">
              <ComboBox
                id="idDivision"
                placeholder="All"
                name="idDivision"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={ filterItems.idDivision}
                items={this.state.divisionOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText="Country">
              <ComboBox
                id="idCountry"
                placeholder="All"
                name="idCountry"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={filterItems.idCountry}
                items={this.state.countryOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            {/* RITM0945977 */}
            {/* <FormGroup legendText="SubDivision"> */}
            <FormGroup legendText="Sub-Business Line">
              <ComboBox
                id="idSubDivision"
                placeholder="All"
                name="idSubDivision"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={filterItems.idSubDivision}
                items={this.state.subDivisionOptions}
              />  
            </FormGroup>
          </div>
          <div className="bx--col-md-4 bx--col-lg-4">
            <FormGroup legendText="Activity">
              <ComboBox
                id="idActivity"
                placeholder="All"
                name="idActivity"
                alt="searchModel"
                onChange={this.handleChangeCombo}
                itemToString={(item) => (item ? item.name : '')}
                initialSelectedItem={filterItems.idActivity}
                items={this.state.activityOptions}
              />  
            </FormGroup>
          </div>
        </Form>
        <div className="searchFormFooter">
          <Button
            className="button--max-width"
            size="small"
            kind="secondary"
            onClick={this.handleClickCancelSearch}
          >
            Cancel
          </Button>
          <Button className="button--max-width" size="small" onClick={() => this.getReportSummaries()}>
            Search
          </Button>
        </div>
      </div>
    );

  getReportSummaries =async () => {
    let data= null;
    if(!this.state.isBack ){
      data = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
         ...this.state.searchModel,
      },
     };
     data.params.page = this.state.currentPage; 
     data.params.pageSize = this.state.pageSize; 
    }else{ 
        let filter = await ReportRepository.getBackPaged()
        data = {
          params: filter?.params
          };
          //RITM0549692;
          if(data.params) data.params.page =1
         //
          this.setState({
          searchModel : filter?.params,
         });

        if (this.state.searchModel?.startDate == undefined && this.state.searchModel?.endDate == undefined && this.state.searchModel?.idWorksite == undefined && this.state.searchModel?.idCompany == undefined &&
            this.state.searchModel?.idDivision == undefined && this.state.searchModel?.idProject == undefined && this.state.searchModel?.idCountry == undefined && this.state.searchModel?.idSubDivision == undefined &&
            this.state.searchModel?.idActivity == undefined) {
            this.setState({
                isOpenFilter: false,
            });
            console.log("sono tutti null");
        }
        else {
            this.setState({
                isOpenFilter: true,
            });
            console.log("NON sono tutti null");
        }
    }
   this.getPagedWithfilter(data);
   };
  handleClickCancelSearch = () => {
    
    this.setState({
      isOpenFilter: false,
      isBack:false,
      searchModel: {
          startDate: null,
          endDate: null,
          idWorksite: null,
          idCompany: null,
          idDivision: null,
          idProject: null,
          idCountry: null,
          idSubDivision: null,
          idActivity: null,
      },
    },
    );
    let params= {
          page: 1,
          pageSize: 10,
          startDate: null,
          endDate: null,
          idWorksite: null,
          idCompany: null,
          idDivision: null,
          idProject: null,
          idCountry: null,
          idSubDivision: null,
          idActivity: null,
        };
    this.getPagedWithfilter({ params });
  };
  getPagedWithfilter = async (data) => {
    this.setState({
      isLoadingList: true,
    });
    
    api
      .getWithParam('/Reports/reportsummaries', data)
      .then((response) => {
        response.data.itemList.forEach((x) => {
          x.start = new Date(x.start).toLocaleDateString();
          x.end = new Date(x.end).toLocaleDateString();
        });
        this.setState({
          itemList: response.data.itemList,
          pageCount: response.data.pageCount,
          rowCount: response.data.rowCount,
          // currentPage : response.data?.currentPage ?response.data.currentPage :1 ,
          //RITM0549692
           currentPage :  data.params?.page ,
          pageSize : response.data?.pageSize ?  response.data.pageSize : 10,
        });
        ReportRepository.updateReportFilter(data);
        ReportRepository.updateReport(data);
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.REPORTSUMMARY, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoadingList: false,
        });
      });
  };
  
  getFilterOptions = async () => {
    this.setState({
      isLoadingOptions: true,
    });
    try {
      const data = (await ReportRepository.getWorkSites()).itemList;
      this.setState({
        workSiteOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.WORKSITE, apioperation.GET));
    }
    try {
      const data = await ReportRepository.getProjects();
        this.setState({
            projectOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.PROJECT, apioperation.GET));
    }
    try {
      const data = await ReportRepository.getDivisions();
      this.setState({
        divisionOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.DIVISION, apioperation.GET));
    }
    try {
      const data = await ReportRepository.getCountry();
      this.setState({
        countryOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.COUNTRY, apioperation.GET));
    }
    try {
      const data = await ReportRepository.getSubDivision();
      this.setState({
        subDivisionOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.SUBDIVISION, apioperation.GET));
    }
    try {
      const data = await ReportRepository.getActivity();
      this.setState({
        activityOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.Activity, apioperation.GET));
    }

    try {
      const data = await ReportRepository.getCompanies();
      this.setState({
        companyOptions: data,
      });
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.COMPANY, apioperation.GET));
    }
    this.setState({
      isLoadingOptions: false,
    });
    // const [workSites, projects, divisions, countries, companies] =
    //     await Promise.all([
    //         api.getWithParam('/WorkSite', {params: {page: 0 } }),
    //         api.getWithParam('/Project'),
    //         api.getWithParam('/Division'),
    //         api.getWithParam('/Country'),
    //         api.getWithParam('/Company'),
    //     ])
    //         .then(response => {
    //             return response.map(r => r.data);
    //         }).catch(error => {
    //             showNotification.error(getError(error, entitiesLabels.REPORTSUMMARY, apioperation.POST));

    //         }).finally(() => {
    //             this.setState({
    //                 isLoadingOptions: false,
    //             });
    //         });
    // this.setState({
    //     workSiteOptions: workSites.itemList.map(w => ({ id: w.id, text: w.name })),
    //     projectOptions: projects.map(p => ({ id: p.id, text: p.name })),
    //     divisionOptions: divisions.map(d => ({ id: d.id, text: d.name })),
    //     countryOptions: countries.map(c => ({ id: c.id, text: c.name })),
    //     companyOptions: companies.map(c => ({ id: c.id, text: c.name })),
    // });
  };

  downloadFile() {
    if (this.state.isExportLoading) return;

    this.setState({
      isExportLoading: true,
    });
    api
      .getWithParam('/reports/excel', { responseType: 'arraybuffer' })
      .then((response) => {
        // fileDownload(new Blob([response.data]), 'report.xlsx');
        const data = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const csvURL = window.URL.createObjectURL(data);
        const tempLink = document.createElement('a');
        tempLink.href = csvURL;

        const nomefile = `${'Export_Report_'}${moment().format('YYYYMMDDHHmmSS')}.xlsx`;
        tempLink.setAttribute('download', nomefile);

        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, 'Download File', apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isExportLoading: false,
        });
      });
  }

  handleChangePaging = (e) => {
    this.setState(
      {
        isBack :false,
        currentPage: e.page,
        pageSize: e.pageSize,
      },
      () => { this.getReportSummaries()}
    );
   
  };

  // QR Code download handlers
  getWorkSiteProjectQrCodeUrl = id => {
    const reports = this.state.itemList || [];
    const element = reports.find((el) => el.id == id);
    return `/worksite/${element.idWorkSite}/project/${element.idProject}/qr-code`;
  };

  getWorkSiteProjectQrCodeFileName = id => {
    const element = (this.state.itemList || []).find((el) => el.id == id);
    return `${element.workSite}_${element.project}_QR Code.pdf`;
  };

  onQrCodeDownloadError = error => {
    showNotification.error(getError(error, entitiesLabels.WORKSITEPROJECT_QRCODE, apioperation.DOWNLOAD));
    this.setState({ isLoadingQrCodeFile: false });
  };

  componentDidMount() {
    this.getFilterOptions();
    this.getReportSummaries();
  }

  render() {
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.rowCount || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });
    const headersDataTable = [
      { key: 'start', header: 'Start Date' },
      { key: 'end', header: 'End Date' },
      { key: 'workSite', header: 'Worksite' },
      { key: 'project', header: 'Project' },
      //RITM0945977
      // { key: 'division', header: 'Division' },
      // { key: 'subDivision', header: 'SubDivision' },
      { key: 'division', header: 'Business Line' },
      { key: 'subDivision', header: 'Sub-Business Line' },
      { key: 'activity', header: 'Activity' },
      { key: 'country', header: 'Country' },
      { key: 'company', header: 'Operating Company/Branch' },
      { key: 'countReports', header: 'N° of report' },
    ];
    const skeletonRowCount =
      this.state.rowCount > 0 && this.state.pageSize > this.state.rowCount
        ? this.state.rowCount
        : this.state.pageSize;

    const filterItems = {
      
        idWorksite: this.state.searchModel?.idWorksite
          ? (this.state.workSiteOptions || []).find((el) => el.id === this.state.searchModel.idWorksite)
          : [],
          idProject: this.state.searchModel?.idProject
          ? (this.state.projectOptions || []).find((el) => el.id === this.state.searchModel.idProject)
          : [],
          idCompany: this.state.searchModel?.idCompany
          ? (this.state.companyOptions || []).find((el) => el.id === this.state.searchModel.idCompany)
          : [],
          idDivision: this.state.searchModel?.idDivision
          ? (this.state.divisionOptions || []).find((el) => el.id === this.state.searchModel.idDivision)
          : [],
          idCountry: this.state.searchModel?.idCountry
          ? (this.state.countryOptions || []).find((el) => el.id === this.state.searchModel.idCountry)
          : [],
          idSubDivision: this.state.searchModel?.idSubDivision
          ? (this.state.subDivisionOptions || []).find((el) => el.id === this.state.searchModel.idSubDivision)
          : [],
          idActivity: this.state.searchModel?.idActivity
          ? (this.state.activityOptions || []).find((el) => el.id === this.state.searchModel.idActivity)
          : [],
          endDate: this.state.searchModel?.endDate
          ? this.state.searchModel?.endDate
          : null,
          startDate: this.state.searchModel?.startDate
          ? this.state.searchModel?.startDate
          : null,
        };
    return (
      <>
        <PageBreadCrumb linkTo="/modules" linkText="Modules" titleLeft="Report Summary" />
        <div className="mainContainer">
          <div className="bx--grid content full-width">
            <div className=" bx--row ">
              <div className="bx--col-lg-12 bx--tab-container">
                <div className="bx--row" />
                <div className="some-content">
                  <TableToolbar>
                    <Search
                      readOnly
                      light
                      className="search cursor-pointer hiddenSearch"
                      labelText="Search"
                      placeHolderText="Search"
                      id="search-1"
                      onClick={this.showDivFilter}
                    />
                    <Online>
                      <FileDownLoadButton
                        onError={(error) => {
                          showNotification.error(`${entitiesLabels.ERROR}`,
                            getError(error, 'Download File', apioperation.GET)
                          );
                        }}
                        className="btn-notext"
                        iconDescription=" "
                        renderIcon={Download16}
                        apiUrl="/reports/excel"
                        fileName={`${'Export_Report_'}${moment().format('YYYYMMDDHHmmSS')}.xlsx`}
                        onDownLoadStart={() => {
                          this.setState({
                            isExportLoading: true,
                          });
                        }}
                        onDownLoadEnd={() => {
                          this.setState({
                            isExportLoading: false,
                          });
                        }}
                      >
                        {!this.state.isExportLoading ? '' : <Loading />}
                      </FileDownLoadButton>
                    </Online>
                    <Button
                      onClick={this.showDivFilter}
                      className="buttonPaddingIcon"
                      renderIcon={Data16}
                      iconDescription="showFilter"
                    />
                  </TableToolbar>

                  {!this.state.isOpenFilter ? '' : this.divFiterAudit(filterItems)}
                  <DataTable
                    rows={this.state.itemList || []}
                    headers={headersDataTable}
                    useZebraStyles
                    size="compact"
                    render={({ rows, headers, getHeaderProps, getRowProps }) => (
                      <TableContainer className="bx--grid--full-width">
                        {this.state.isLoadingList ? (
                          <DataTableSkeleton
                            headers={[]}
                            rowCount={skeletonRowCount}
                            zebra={false}
                            compact={false}
                          />
                        ) : (
                          <Table className="">
                            <TableHead className="colorgray">
                              <TableRow>
                                {headers.map((header) => (
                                  <TableHeader
                                    className={header.type == 'bool' ? 'align-center' : ''}
                                    {...getHeaderProps({ header })}
                                  >
                                    {header.header}
                                  </TableHeader>
                                ))}
                                <TableHeader className="align-center">Actions</TableHeader>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {rows == null || rows.length == 0 ? (
                                <NoRecordsPlaceholder colSpan={headers.length + 1} />
                              ) : (
                                rows.map((row) => (
                                  <TableRow {...getRowProps({ row })}>
                                    {row.cells.map((cell) => (
                                      <RenderDataTableCell
                                        key={cell.id}
                                        cell={cell}
                                        header={headers.find((x) => x.key === cell.info.header)}
                                      />
                                    ))}

                                    <TableCell
                                      key={`action-${row.id}`}
                                      className="tableActions align-center"
                                    >
                                      <div>
                                        <Link to={`/reportSummaries/${row.id}`}>
                                          <Button
                                            size="small"
                                            renderIcon={FolderDetail16}
                                            iconDescription="Folder"
                                            kind="ghost"
                                          />
                                        </Link>
                                        <FileDownLoadButton
                                          onError={this.onQrCodeDownloadError}
                                          size="small"
                                          className="bx--export--qr-code"
                                          renderIcon={ExportDoc16}
                                          iconDescription="Download QR Code"
                                          title="Download QR Code"
                                          kind="ghost"
                                          apiUrl={this.getWorkSiteProjectQrCodeUrl(row.id)}
                                          // fileName={`Audit_Report_${row.auditCode}.pdf`}
                                          fileName={this.getWorkSiteProjectQrCodeFileName(row.id)}
                                          onDownLoadStart={() => { this.setState({ isLoadingQrCodeFile: true, }); }}
                                          onDownLoadEnd={() => { this.setState({ isLoadingQrCodeFile: false, }); }}
                                        />
                                      </div>
                                    </TableCell>
                                  </TableRow>
                                ))
                              )}
                            {!this.state.isLoadingQrCodeFile ? '' : <Loading />}
                            </TableBody>
                          </Table>
                        )}
                      </TableContainer>
                    )}
                  />
                </div>
                <div className="footer-pagination">
                  <Pagination {...paginationProps()} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
